class CartRecommendations extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    const baseUrl = this.dataset.url;
    const grid = this.querySelector('[data-recommendations-grid]');
    if (!productId || !baseUrl || !grid) return;

    const bagIcon =
      '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686"/></svg>';

    fetch(`${baseUrl}.json?product_id=${productId}&limit=4&intent=related`)
      .then((res) => res.json())
      .then((data) => {
        const products = (data && data.products) || [];
        if (!products.length) {
          this.remove();
          return;
        }
        grid.innerHTML = products
          .map((product) => {
            const image = product.featured_image || (product.images && product.images[0]) || '';
            const price = (product.price / 100).toFixed(2).replace('.', ',');
            const hasCompare = product.compare_at_price && product.compare_at_price > product.price;
            const comparePrice = hasCompare
              ? (product.compare_at_price / 100).toFixed(2).replace('.', ',')
              : null;
            const variant =
              (product.variants || []).find((v) => v.available) || (product.variants || [])[0];
            const variantId = variant ? variant.id : '';
            const tags = product.tags || [];
            const hasLeve3 = tags.indexOf('Leve 3 Pague 2') !== -1;

            const badges = `
              ${hasCompare ? '<span class="cart-recommendations__promo-badge">Promoção</span>' : ''}
              ${hasLeve3 ? '<span class="cart-recommendations__badge">Leve 3 Pague 2</span>' : ''}
            `;

            const priceMarkup = hasCompare
              ? `<span class="cart-recommendations__compare-price">R$ ${comparePrice}</span> <span class="cart-recommendations__sale-price">R$ ${price}</span>`
              : `R$ ${price}`;

            return `
              <div class="cart-recommendations__card">
                <a href="${product.url}" class="cart-recommendations__link">
                  <span class="cart-recommendations__image-wrap">
                    <span class="cart-recommendations__badges">${badges}</span>
                    <img src="${image}" alt="${product.title}" loading="lazy" width="150" height="150">
                  </span>
                  <span class="cart-recommendations__info">
                    <span class="cart-recommendations__name">${product.title}</span>
                    <span class="cart-recommendations__price">${priceMarkup}</span>
                  </span>
                </a>
                ${
                  variantId
                    ? `<button type="button" class="cart-recommendations__add" data-variant-id="${variantId}" aria-label="Adicionar ${product.title} ao carrinho">${bagIcon}</button>`
                    : ''
                }
              </div>
            `;
          })
          .join('');

        grid.querySelectorAll('.cart-recommendations__add').forEach((button) => {
          button.addEventListener('click', (event) => this.handleAdd(event));
        });
      })
      .catch(() => {
        this.remove();
      });
  }

  handleAdd(event) {
    const button = event.currentTarget;
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    button.disabled = true;
    const originalContent = button.innerHTML;
    button.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(() => this.refreshCartDrawer())
      .catch(() => {
        button.disabled = false;
        button.innerHTML = originalContent;
      });
  }

  refreshCartDrawer() {
    fetch(`/?sections=cart-drawer-section`)
      .then((res) => res.json())
      .then((sections) => {
        const html = sections['cart-drawer-section'];
        const container = document.getElementById('shopify-section-cart-drawer-section');
        if (!html || !container) return;

        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newContainer =
          temp.querySelector('#shopify-section-cart-drawer-section') || temp.firstElementChild;
        if (!newContainer) return;

        container.replaceWith(newContainer);

        const reopen = () => {
          const newDialog = newContainer.querySelector('dialog[ref="panel"]');
          if (newDialog && !newDialog.hasAttribute('open')) {
            try {
              newDialog.showModal();
            } catch (e) {
              newDialog.setAttribute('open', '');
            }
          }
        };

        requestAnimationFrame(() => requestAnimationFrame(reopen));

        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
